<template>
  <div class="layout-wrapper layout-content-navbar">
    <!-- Sidebar -->
    <aside class="layout-menu menu-vertical menu bg-menu-theme" :class="{ 'menu-collapsed': menuCollapsed }">
      <div class="menu-inner-shadow"></div>
      <div style="padding: 1.5rem">
        <a href="/" class="app-brand-link" style="text-decoration: none;">
            <span class="app-brand-logo demo">
                <svg xmlns="http://www.w3.org/2000/svg" width="62" height="55" viewBox="0 0 62 42" fill="none" style="width: 22px; height: 38px;">
                    <g clip-path="url(#clip0_1191_534)">
                        <path d="M42.4748 19.9076C42.1638 19.6937 41.8684 19.5576 42.1872 19.1337C42.3232 18.9549 42.0705 18.8732 41.9112 18.8887C40.9744 18.9665 40.0453 18.8382 39.1163 18.7954C39.0036 18.7915 38.887 18.8265 38.7742 18.8382C38.5216 18.8693 38.2572 18.9704 38.0473 18.7176C37.9813 18.6399 37.8608 18.6437 37.8024 18.6787C37.1611 19.0482 36.5897 18.671 35.9794 18.5582C35.4274 18.4571 34.856 18.4843 34.304 18.3132C33.9658 18.2082 33.8103 18.6243 33.4877 18.6593C33.1767 18.6904 32.893 18.8421 32.5703 18.6554C32.3682 18.5387 32.2322 18.6826 32.2399 18.9043C32.2633 19.4915 32.2283 20.0787 32.2477 20.666C32.2633 21.1443 32.3604 21.6654 32.1894 22.1554C32.1 22.4082 32.1389 22.6765 32.1466 22.9371C32.1466 23.0732 32.1816 23.2249 32.306 23.2793C33.169 23.6565 32.9202 24.4226 32.8502 25.0449C32.7492 25.916 32.7647 26.7793 32.7686 27.6465C32.7725 28.5293 32.8114 29.4082 32.7686 30.2948C32.7336 30.9676 32.582 31.6637 32.9552 32.3054C33.0018 32.3832 33.0135 32.5154 32.9824 32.6048C32.7103 33.4371 32.8735 34.2771 32.9008 35.1171C32.928 35.9026 32.9163 36.6882 32.963 37.4698C32.9824 37.7771 32.7997 38.026 32.8191 38.3254C32.8502 38.8154 32.7453 39.3015 32.8969 39.7954C33.0601 40.3165 32.7103 40.6821 32.3604 41.001C32.1972 41.1487 32.0106 41.1021 31.8551 40.9465C31.7191 40.8104 31.6802 40.6432 31.6919 40.4643C31.7696 39.1149 31.4897 37.8004 31.3265 36.4743C31.2332 35.7121 31.2254 34.946 31.2409 34.1721C31.2526 33.6704 31.307 33.1104 30.8328 32.7215C30.5879 32.5232 30.3819 32.4843 30.0942 32.6943C29.6006 33.056 29.1497 33.4604 28.691 33.861C28.31 34.1954 28.4033 34.5493 28.551 34.8837C28.9398 35.7432 29.379 36.5832 29.791 37.431C29.9582 37.7693 29.791 38.5432 29.5034 38.7804C29.274 38.9671 29.0019 38.9476 28.8309 38.7376C28.3645 38.1698 27.9058 37.6021 27.3149 37.151C27.1439 37.0187 27.105 36.7154 27.004 36.4898C26.5025 35.3465 26.2421 34.1137 25.7601 32.9626C25.3791 32.0565 25.0254 31.1348 24.6483 30.2248C24.5939 30.0965 24.4773 29.9915 24.3762 29.8904C24.1663 29.6726 23.9603 29.4004 24.0031 29.1282C24.1275 28.3193 23.6377 27.6893 23.4356 26.9854C23.0041 25.4804 22.3316 24.0571 21.7563 22.5987C21.216 21.226 20.493 19.9387 19.9682 18.5621C19.9527 18.5232 19.9293 18.4843 19.9138 18.4415C19.5989 17.5782 19.9371 17.201 20.8506 17.2632C22.6115 17.3837 24.3762 17.5393 26.1488 17.3526C26.9262 17.271 27.7192 17.3176 28.5044 17.3332C28.827 17.3371 29.1419 17.271 29.4606 17.271C29.8299 17.271 30.1914 17.5082 30.5685 17.1971C30.6929 17.096 30.8989 17.3137 31.031 17.4499C31.1321 17.551 31.2098 17.6949 31.3809 17.6871C31.5247 17.6793 31.7074 17.8426 31.8046 17.6171C31.894 17.4032 31.789 17.2476 31.6025 17.1504C31.3614 17.026 31.1438 16.8899 31.0932 16.5982C30.9883 16.011 31.3265 15.6337 31.9445 15.6026C32.0806 15.5949 32.3527 15.766 32.3449 15.4549C32.3371 15.2176 32.1039 15.1904 31.9056 15.2021C31.6802 15.2137 31.4742 15.1554 31.2643 15.0854C30.9805 14.9882 31.0155 14.8443 31.1904 14.6732C31.2759 14.5915 31.3653 14.5021 31.4858 14.5021C32.4421 14.4982 33.34 14.1599 34.2885 14.0626C35.8278 13.9071 37.3515 13.9732 38.8831 14.0043C39.2601 14.0121 39.6411 14.0354 40.0142 13.946C40.0959 13.9265 40.2008 13.9149 40.2747 13.946C41.0327 14.2765 41.8256 14.0626 42.5992 14.086C42.9257 14.0937 43.2406 14.121 43.5438 14.2299C43.6992 14.2882 43.8509 14.3115 44.0141 14.2687C44.3173 14.191 44.6011 14.1404 44.6827 14.5682C44.7099 14.6965 44.8576 14.7315 44.9198 14.6499C45.1608 14.3387 45.499 14.4049 45.8216 14.3504C46.3581 14.2571 46.8712 14.3115 47.4037 14.3854C47.9324 14.4593 48.4571 14.6343 49.0091 14.5293C49.1957 14.4943 49.4056 14.5837 49.6038 14.6304C49.7166 14.6576 49.8293 14.7276 49.942 14.6654C50.4085 14.3971 50.9293 14.5954 51.4191 14.4865C51.6718 14.4321 51.9167 14.5215 52.1693 14.6382C52.6203 14.8482 53.1139 14.8715 53.6231 14.8987C54.2412 14.9337 54.8826 14.891 55.4851 15.0349C56.453 15.2643 57.382 14.9415 58.3305 14.9337C59.0029 14.9299 59.6638 14.7704 60.3401 14.8287C60.6356 14.856 60.7716 15.0232 60.7366 15.2915C60.6705 15.8204 60.8999 16.081 61.413 16.1393C61.7317 16.1743 61.9066 16.3649 61.9494 16.6799C62.0155 17.201 62.0893 17.7143 61.5957 18.111C61.3702 18.2937 61.1797 18.3832 60.8921 18.2432C60.6045 18.1071 60.2935 18.1849 59.9942 18.2665C59.7454 18.3365 59.7298 18.5349 59.7065 18.7487C59.6404 19.3787 59.9553 19.9426 59.9981 20.5493C60.0641 21.4437 60.1808 22.3343 60.103 23.2404C60.068 23.6565 60.1458 24.0765 60.1613 24.4965C60.2041 25.7021 60.3246 26.8998 60.2468 28.1093C60.1808 29.1787 60.3362 30.2521 60.3051 31.3293C60.2702 32.4143 60.1846 33.4993 60.2274 34.5843C60.2468 35.1093 60.1885 35.6343 60.309 36.1515C60.4373 36.6921 60.1147 37.2132 60.2041 37.7382C60.2935 38.2593 59.9553 38.7921 60.274 39.2937C60.2818 39.3054 60.2779 39.321 60.2857 39.3365C60.4451 39.7176 60.4218 40.1065 60.2157 40.4993C60.1574 40.6121 60.173 40.721 60.1963 40.8376C60.243 41.0515 60.1224 41.1565 59.9359 41.2265C59.7337 41.3043 59.6443 41.176 59.5433 41.0437C59.4577 40.931 59.45 40.8026 59.4305 40.6704C59.3839 40.4099 59.209 40.2776 58.968 40.3087C58.5909 40.3593 58.2139 40.3554 57.8329 40.3632C57.7124 40.3632 57.6114 40.406 57.5181 40.4876C56.9505 40.9893 56.247 40.9737 55.7222 40.4565C55.5084 40.2426 55.2285 40.2076 54.9525 40.1999C53.4793 40.161 52.0177 40.3048 50.5523 40.4137C50.0003 40.4565 49.4522 40.5537 48.9003 40.5498C47.9946 40.546 47.1122 40.7287 46.222 40.8532C45.81 40.9115 45.3746 40.8726 44.9859 41.0671C44.8693 41.1254 44.7177 41.141 44.6322 41.2265C44.0957 41.7632 43.4777 41.6154 42.8324 41.5026C42.296 41.4093 41.7557 41.3082 41.2115 41.2421C40.1153 41.1021 39.0152 41.0865 37.9191 41.036C37.5809 41.0204 37.2388 40.8882 36.9123 40.7715C36.578 40.651 36.3836 40.4021 36.4497 40.0248C36.5158 39.6515 36.819 39.6593 37.0989 39.6671C37.4915 39.6787 37.8841 39.7021 38.2767 39.7293C38.5877 39.7526 38.817 39.6554 38.9453 39.356C39.0697 39.0682 39.2796 38.9554 39.6061 38.971C40.0142 38.9904 40.4263 38.9671 40.6556 38.516C40.7295 38.3721 40.8966 38.3876 41.0482 38.3993C42.7974 38.5198 44.5389 38.7921 46.3036 38.6871C46.8323 38.656 47.3804 38.7571 47.9013 38.8737C48.6981 39.0526 49.4989 38.8893 50.2957 38.9398C50.7039 38.9632 50.8827 38.6365 50.7467 38.2437C50.2685 36.8865 49.8098 35.5176 49.2112 34.2071C49.1685 34.1137 49.1451 34.0126 49.1218 33.9154C48.8497 32.7798 48.3288 31.726 47.9635 30.6215C47.6836 29.7698 47.4581 28.8987 47.1549 28.0587C46.7157 26.826 46.2492 25.6048 45.8683 24.3526C45.7711 24.0299 45.569 24.061 45.3979 24.2943C45.0986 24.7104 44.8848 25.1732 44.6827 25.6399C44.3989 26.2932 44.1152 26.9465 43.8664 27.6076C43.3922 28.8598 42.9451 30.1199 42.4787 31.376C42.3776 31.6482 42.2416 31.9048 42.1444 32.1771C41.7868 33.1687 41.4914 34.1876 41.0677 35.1482C40.8266 35.7004 40.7023 36.2682 40.5312 36.8321C40.3641 37.3843 39.5711 37.8043 39.0152 37.6565C38.8986 37.6254 38.8092 37.5476 38.7393 37.4543C38.646 37.326 38.5721 37.1782 38.4594 37.0654C38.3039 36.9098 38.2339 36.5987 37.9502 36.661C37.6819 36.7154 37.6664 36.9993 37.5925 37.2171C37.4526 37.641 37.1533 37.9793 36.9939 38.4071C36.8462 38.7999 36.2087 38.7376 35.8977 38.3487C35.6567 38.0493 35.5479 37.6915 35.6295 37.3221C35.7423 36.8126 35.89 36.311 36.0532 35.8171C36.1582 35.4943 36.3059 35.1715 36.2515 34.841C36.1115 33.9854 36.5352 33.2504 36.7335 32.4765C36.9978 31.4382 37.4565 30.466 38.0085 29.5326C38.471 28.751 38.7509 27.8682 39.1746 27.0554C39.3495 26.7171 39.6216 26.4526 39.7421 26.0482C39.9482 25.3482 40.3058 24.691 40.644 24.0376C41.1726 23.0226 41.5302 21.9415 41.9384 20.8798C41.985 20.7632 41.9928 20.6232 41.9889 20.4949C41.9811 20.1721 42.02 19.8999 42.4748 19.8804V19.9076ZM58.3577 20.4054C58.3577 20.2382 58.3577 20.1487 58.3577 20.0632C58.3577 19.3437 58.3344 19.301 57.6386 19.1726C56.6007 18.986 55.5512 19.0365 54.5016 19.0637C53.8952 19.0793 53.2888 19.0793 52.6824 19.056C51.664 19.0171 50.6495 19.0443 49.6271 18.9704C49.1879 18.9393 48.737 19.1882 48.3211 18.8265C48.2161 18.7332 48.0645 18.8148 47.9751 18.9276C47.8702 19.056 47.9207 19.1726 48.0334 19.2699C48.2433 19.4487 48.3444 19.6937 48.4105 19.9465C48.4766 20.2032 48.6126 20.3976 48.8303 20.5337C49.114 20.7087 49.2579 20.9615 49.2967 21.2843C49.3939 22.1126 49.8293 22.8165 50.1869 23.536C50.494 24.1582 50.7894 24.8115 50.9721 25.4454C51.2559 26.4254 51.7456 27.3315 51.9322 28.3348C51.9517 28.4437 52.0566 28.4904 52.1188 28.5682C52.5969 29.1243 53.0634 29.7076 53.1722 30.4426C53.3238 31.481 53.938 32.3598 54.0935 33.3826C54.0974 33.4098 54.1168 33.4371 54.1324 33.4604C54.9836 35.086 55.6328 36.801 56.4025 38.4654C56.6551 39.0098 56.9894 39.4143 57.5453 39.5854C57.9612 39.7099 58.4082 39.6165 58.828 39.5465C59.0885 39.5037 59.2751 39.3482 59.345 38.9982C59.4422 38.5276 59.275 38.1465 59.174 37.7265C59.0224 37.0965 58.6104 36.5521 58.692 35.8482C58.8319 34.6465 58.6453 33.441 58.657 32.2354C58.6725 30.7965 58.6065 29.346 58.6376 27.9071C58.6648 26.6743 58.6142 25.4493 58.5909 24.2204C58.5754 23.4232 58.3771 22.6337 58.5326 21.8326C58.5559 21.7121 58.5248 21.5682 58.4821 21.4476C58.3577 21.0821 58.3266 20.7087 58.3499 20.4054H58.3577ZM30.2964 28.6382C30.2964 28.5993 30.2964 28.4787 30.2808 28.366C30.2342 28.1015 30.0865 27.9654 29.8766 28.2065C29.4334 28.7082 28.8814 29.101 28.4966 29.6493C28.3683 29.8282 28.209 30.0499 28.38 30.2404C28.6988 30.5865 28.3606 30.6915 28.1934 30.8393C28.0302 30.9793 27.8164 31.0571 27.6376 31.1776C27.4004 31.3371 27.2994 31.5626 27.3382 31.8543C27.3888 32.2393 27.6298 32.3598 27.933 32.1265C28.174 31.9398 28.3994 31.7337 28.6171 31.5198C28.9009 31.2399 28.9864 30.8587 28.9786 30.4893C28.9709 30.0926 29.103 29.836 29.4956 29.7426C30.1759 29.5754 30.2964 29.4276 30.3003 28.6421L30.2964 28.6382ZM47.1588 21.4826C47.1472 21.3776 47.1472 21.2571 47.1161 21.1482C47.0811 21.0276 47.0577 20.8604 46.8945 20.8643C46.7429 20.8643 46.7001 21.016 46.6535 21.1404C46.4863 21.5721 46.5874 22.2176 46.9334 22.416C47.2327 22.5871 47.3376 22.8321 47.4542 23.116C47.7108 23.7382 48.0295 24.3332 48.0334 25.0332C48.0334 25.1654 48.1189 25.356 48.29 25.3326C48.4532 25.3093 48.391 25.1226 48.4027 24.9982C48.4649 24.1621 47.9207 23.4971 47.7652 22.7193C47.7186 22.4782 47.5553 22.2837 47.3687 22.1049C47.2055 21.9493 47.0228 21.7704 47.1549 21.4826H47.1588ZM52.6786 37.1743C52.5192 37.1743 52.4687 37.2521 52.5231 37.3998C52.628 37.6876 52.6786 38.0104 52.8457 38.2515C53.0634 38.5626 53.2266 38.9476 53.6231 39.1071C53.7553 39.1615 53.8836 39.1654 54.0002 39.0915C54.1401 39.0021 54.0352 38.8776 54.0119 38.7765C53.9263 38.411 53.7747 38.096 53.3977 37.9365C53.1839 37.8432 52.9973 37.7265 52.9779 37.4387C52.9701 37.291 52.8457 37.1821 52.6747 37.1743H52.6786ZM24.4851 18.6904C24.0614 18.5932 23.9642 19.021 23.731 19.2465C23.661 19.3126 23.7154 19.4099 23.7621 19.4876C23.8359 19.6043 23.9331 19.5654 24.0303 19.5265C24.2557 19.4371 24.489 19.3515 24.7105 19.2543C24.8777 19.1804 25.1381 19.1221 25.107 18.9237C25.072 18.6982 24.8116 18.6943 24.6056 18.6943C24.5784 18.6943 24.5473 18.6943 24.4851 18.6943V18.6904Z" fill="#A61E2F"></path>
                        <path d="M44.0841 3.14965C44.741 3.51521 45.4563 3.46854 46.1521 3.54243C47.602 3.69798 49.0558 3.6941 50.5095 3.78354C51.5124 3.84576 52.5153 3.66298 53.5221 3.70576C54.7271 3.76021 55.9321 3.7641 57.1332 3.54632C57.4442 3.48798 57.7396 3.39854 57.9923 3.24687C58.3577 3.0291 58.1944 2.62465 58.2022 2.29021C58.2061 2.11132 58.1011 1.92465 58.2761 1.75743C58.4549 1.58243 58.6376 1.46187 58.8941 1.5241C59.1546 1.59021 59.3256 1.75743 59.4033 2.0141C59.4733 2.23187 59.4966 2.45743 59.621 2.67132C59.8776 3.12243 60.2274 3.33632 60.7405 3.37132C61.0709 3.39465 61.3974 3.49576 61.689 3.66687C61.8795 3.77965 62 3.94298 61.9378 4.17632C61.8639 4.44076 61.6346 4.4291 61.4363 4.39798C61.1603 4.35132 60.8882 4.33187 60.6084 4.34743C60.0642 4.37465 59.9126 4.52632 59.9048 5.06687C59.897 5.47521 59.9087 5.88354 59.9009 6.29187C59.8853 6.98798 59.9398 7.68798 59.827 8.3841C59.7571 8.81187 59.8853 9.25521 59.8815 9.68687C59.8737 10.5852 59.7843 11.4835 59.7104 12.3819C59.691 12.6385 59.5277 12.8058 59.2479 12.8135C59.0885 12.8174 58.9252 12.8174 58.7658 12.8135C58.4354 12.8097 58.2255 12.6852 58.1789 12.3119C58.0545 11.363 57.9923 10.4141 58.0195 9.45354C58.0623 8.00298 58.105 6.54854 58.0312 5.0941C58.0117 4.75187 57.8835 4.57687 57.4753 4.63521C57.0205 4.69743 56.5463 4.65854 56.0837 4.65076C55.1547 4.63132 54.2412 4.86465 53.3005 4.68965C52.7719 4.59243 52.2082 4.65854 51.664 4.65854C49.5067 4.65854 47.3648 4.40576 45.2153 4.33576C43.4622 4.27743 41.7246 4.01687 39.9637 4.0441C39.4117 4.05187 38.817 3.90798 38.265 3.94298C37.612 3.98576 36.9978 3.8341 36.3642 3.81854C35.2059 3.79132 34.0591 3.54243 32.893 3.6241C32.6598 3.63965 32.4265 3.61632 32.1933 3.6241C31.5869 3.64354 31.1671 3.88465 31.2176 4.7441C31.2526 5.31965 31.4081 5.87965 31.3809 6.4591C31.3692 6.70798 31.5053 6.78187 31.758 6.69632C32.3993 6.47465 32.4732 6.57965 32.4693 7.23298C32.4654 7.61021 32.5976 7.99521 32.5781 8.38798C32.5665 8.60576 32.5665 8.81576 32.4188 9.00632C32.2905 9.16965 32.2749 9.35243 32.4188 9.54298C32.5198 9.6791 32.6092 9.84243 32.4771 10.0252C32.3877 10.1458 32.4576 10.2663 32.4965 10.3947C32.5859 10.6708 32.6015 10.9585 32.4693 11.2347C32.446 11.2852 32.3877 11.3747 32.3993 11.3824C32.757 11.6897 32.5082 11.8413 32.2866 12.0863C32.0728 12.3274 32.1078 12.6852 32.205 13.008C32.2866 13.2841 32.2516 13.5641 32.1117 13.7974C31.894 14.163 30.5957 14.1085 30.3702 13.743C30.2886 13.6108 30.308 13.463 30.3042 13.3152C30.2964 12.8797 30.3042 12.4402 30.2847 12.0047C30.277 11.8335 30.2459 11.6041 29.9776 11.7947C29.5034 12.1369 29.138 11.8997 28.7804 11.5885C28.345 11.2113 27.828 11.2191 27.5093 11.6041C27.4082 11.7285 27.3733 11.8219 27.451 11.9891C27.6765 12.4908 27.9641 12.8641 28.5899 12.8213C28.7726 12.8058 28.9631 12.8758 29.1497 12.8952C29.4179 12.9263 29.6433 13.008 29.6589 13.3269C29.6783 13.6341 29.6356 13.8908 29.2896 14.0347C28.9398 14.1785 28.5899 14.2213 28.2245 14.1941C26.7591 14.0813 25.2936 14.058 23.8243 14.0658C22.4016 14.0735 20.9789 14.0697 19.5562 13.9958C18.8954 13.9608 18.2074 13.7858 17.5388 14.023C17.1345 14.163 16.7769 13.9063 16.3921 13.848C15.6963 13.743 15.0043 13.8169 14.3124 13.8558C12.4894 13.9608 10.6702 13.9297 8.84711 13.8169C8.60222 13.8013 8.35344 13.8091 8.10466 13.8013C6.76748 13.7663 5.42642 13.7391 4.08924 13.6885C3.65777 13.673 3.36623 13.8441 3.16021 14.2097C2.97752 14.5402 2.7715 14.9563 2.37112 14.9058C1.97852 14.8552 1.84636 14.3963 1.75695 14.0385C1.63256 13.5447 1.20886 13.5758 0.870682 13.4591C0.703535 13.4008 0.466419 13.463 0.45087 13.183C0.439208 12.9263 0.583033 12.7513 0.808487 12.693C1.38767 12.5452 1.51595 12.1602 1.51595 11.608C1.51595 9.96687 1.55871 8.32187 1.59758 6.68076C1.6209 5.65798 1.51984 4.64298 1.42654 3.62798C1.40711 3.42187 1.47708 3.29743 1.64034 3.19243C1.74529 3.12243 1.90078 3.06798 1.83469 2.90076C1.78027 2.76465 1.63256 2.73354 1.5004 2.74132C1.18943 2.75298 0.897892 2.66354 0.598581 2.60132C0.272061 2.53521 0.128237 2.32521 0.0388323 2.05687C-0.0738949 1.71854 0.0738167 1.50076 0.431434 1.51632C0.979522 1.53965 1.53538 1.4541 2.08347 1.60576C2.50717 1.72243 2.94642 1.73798 3.38178 1.63687C3.58002 1.59021 3.72385 1.66798 3.83657 1.82354C3.96485 2.00632 4.17864 2.13854 4.35745 2.08021C5.04548 1.85465 5.7646 2.17743 6.43319 1.94798C7.06679 1.72632 7.66153 1.99854 8.27181 1.99465C9.95883 1.9791 11.6808 2.31743 13.3173 1.57076C13.6166 1.43465 13.947 1.45798 14.2153 1.71076C14.3591 1.84687 14.5457 1.91687 14.7322 1.93243C15.4475 1.98298 16.1588 2.20076 16.878 1.99465C16.9946 1.95965 17.1073 2.00243 17.22 2.02576C17.5815 2.10354 17.9197 2.28243 18.3201 2.04521C18.6038 1.8741 18.9576 2.0841 19.2919 2.08021C20.4075 2.06854 21.5231 2.21632 22.6387 2.19298C23.7077 2.16965 24.7766 2.25132 25.8534 2.18132C26.8291 2.11521 27.8164 2.02576 28.8037 2.14632C29.3285 2.21243 29.5889 1.93632 29.585 1.40743C29.585 1.15854 29.6045 0.917429 29.6395 0.672429C29.7017 0.229096 30.0243 0.112429 30.3625 0.0268733C30.6657 -0.0509044 30.8678 0.0890956 30.9183 0.415762C30.9805 0.847429 31.0505 1.27521 31.1166 1.70687C31.206 2.28243 31.2876 2.38354 31.7929 2.2941C32.0339 2.25132 32.2827 2.27854 32.5276 2.35243C32.8502 2.44965 33.1845 2.49632 33.4955 2.29798C33.5188 2.28243 33.5499 2.27854 33.581 2.27465C34.6927 2.19298 35.8084 2.15798 36.9123 2.01021C37.7208 1.90132 38.4711 2.26298 39.2796 2.14243C39.7849 2.06465 40.3252 2.16187 40.8422 2.22021C41.8451 2.3291 42.848 2.24354 43.8509 2.26298C44.9315 2.28243 45.9966 2.09965 47.0655 2.08021C48.7992 2.04521 50.5406 2.0491 52.2743 2.18521C52.4726 2.20076 52.6825 2.15798 52.8729 2.09965C53.3588 1.9441 53.8292 2.10743 54.3034 2.14632C54.5366 2.16576 54.6532 2.35243 54.6222 2.58965C54.5872 2.85021 54.3889 3.02132 54.1674 2.94743C53.627 2.76076 53.0673 2.88521 52.527 2.76854C52.4143 2.74521 52.2899 2.72576 52.181 2.74521C51.4347 2.85798 50.6767 2.73743 49.9304 2.88132C49.5416 2.9591 49.1413 2.86187 48.7603 2.79965C48.3055 2.72576 47.8624 2.74132 47.4154 2.80743C46.7507 2.90465 46.0899 2.97854 45.4174 2.91632C44.9548 2.87354 44.5506 3.1341 44.0919 3.15354L44.0841 3.14965ZM16.2171 12.2108C16.3493 12.203 16.4815 12.2147 16.6097 12.1874C16.9674 12.1019 17.2628 11.8491 17.6049 11.7519C18.3512 11.538 18.6622 11.0247 18.7321 10.3052C18.7438 10.2041 18.8021 10.1613 18.8798 10.1108C19.3113 9.82298 19.3657 9.65965 19.1286 9.22021C18.977 8.94021 18.8993 8.66021 18.9226 8.34521C18.9459 8.06132 18.7982 7.88632 18.6 7.68021C18.3279 7.39632 17.9042 7.38465 17.6826 7.16687C17.1073 6.59521 16.4348 6.66132 15.7662 6.71576C15.3892 6.74687 14.9655 6.85965 14.6856 7.12798C14.5379 7.26798 14.4563 7.33021 14.3085 7.24076C13.9665 7.03465 13.7799 7.29521 13.6983 7.51298C13.6244 7.70743 13.4845 7.85521 13.4262 8.03798C13.2435 8.60576 12.9092 9.16187 13.1696 9.79576C13.2979 10.1147 13.3406 10.4374 13.3096 10.7797C13.2862 11.0402 13.3717 11.2463 13.6011 11.4135C14.3824 11.9891 15.3581 11.9113 16.2171 12.2147V12.2108ZM21.5037 3.70187C21.2277 3.62798 21.0217 3.41798 20.7301 3.4141C19.3424 3.39465 17.9547 3.37521 16.5709 3.34798C16.1355 3.34021 15.704 3.28576 15.2687 3.27021C15.0393 3.26243 14.8372 3.35965 14.9383 3.63965C15.0393 3.91965 15.2259 4.19965 15.5369 4.21521C16.2327 4.2541 16.9129 4.43298 17.6165 4.40576C18.942 4.35521 20.2092 3.99354 21.5037 3.70187ZM3.14855 9.40298C3.1641 9.58965 3.14855 9.78798 3.20297 9.96299C3.25739 10.1458 3.30792 10.4141 3.56447 10.3869C3.87156 10.3519 4.13589 10.173 4.30692 9.90465C4.36523 9.81521 4.27971 9.74521 4.20585 9.69465C3.89099 9.48076 3.77438 9.20465 3.89877 8.83132C3.94153 8.70687 3.93764 8.5591 3.78993 8.4891C3.6461 8.4191 3.51394 8.4541 3.38567 8.55521C3.10579 8.78465 3.1641 9.10354 3.14466 9.40298H3.14855ZM28.3295 8.85854C28.8037 8.67576 29.3518 8.4191 29.861 8.08854C30.0632 7.95632 30.067 7.70354 30.001 7.48965C29.9465 7.2991 29.826 7.15521 29.6356 7.37298C29.3985 7.6491 29.0797 7.78521 28.7649 7.93687C28.4889 8.0691 28.2323 8.24021 28.0302 8.47354C27.9563 8.5591 27.863 8.6641 27.9369 8.78465C27.9952 8.88187 28.1235 8.8391 28.3295 8.85854ZM11.2144 4.40187C11.296 4.37854 11.4282 4.37465 11.5137 4.31243C11.8558 4.05187 12.2678 4.04021 12.6643 3.95465C12.7926 3.92743 12.917 3.88854 13.0375 3.8341C13.1774 3.77187 13.3873 3.73687 13.3601 3.53465C13.329 3.30521 13.1035 3.33632 12.9364 3.33243C12.1667 3.30521 11.5914 3.73298 11.0278 4.17243C10.9889 4.20354 10.9501 4.27354 10.9578 4.31243C10.9889 4.42132 11.0978 4.38632 11.2144 4.40187Z" fill="#A61E2F"></path>
                        <path d="M11.642 40.0903C11.4632 40.0126 11.2883 39.927 11.1095 39.857C10.6702 39.6898 10.4914 39.3903 10.6974 38.9703C10.9579 38.4337 10.6314 37.9437 10.6586 37.4303C10.6702 37.2514 10.4837 37.267 10.3554 37.3292C10.1999 37.407 10.0561 37.4926 9.86948 37.5081C9.04152 37.582 8.55951 36.9364 8.88603 36.1587C9.30196 35.167 9.83839 34.2337 10.3204 33.2731C10.5692 32.7792 10.8452 32.297 10.9579 31.7487C11.0084 31.4998 11.1367 31.2898 11.2689 31.0798C12.0191 29.882 12.6138 28.6026 13.2552 27.3503C13.8383 26.2148 14.4602 25.0948 15.0666 23.9709C15.2687 23.6014 15.3698 23.1853 15.6186 22.8353C15.9995 22.3026 16.7497 22.2753 17.1307 22.8081C17.4766 23.2903 17.5466 23.8931 17.8304 24.4026C18.3979 25.4253 18.5884 26.5881 19.0159 27.6653C19.5563 29.0264 19.9838 30.4303 20.7146 31.7137C20.769 31.8109 20.8157 31.9314 20.8235 32.0403C20.8623 32.7792 21.2588 33.3742 21.5815 34.0003C22.0285 34.8676 22.3433 35.7853 22.5882 36.7303C22.7437 37.3331 22.907 37.932 23.2607 38.457C23.4551 38.7487 23.3346 39.3709 23.0741 39.5848C22.9769 39.6626 22.8642 39.7248 22.7515 39.6626C22.4094 39.472 22.0324 39.2814 21.9235 38.8731C21.8458 38.5737 21.7175 38.3753 21.4337 38.2587C21.1733 38.1498 21.0334 37.9903 21.0684 37.6559C21.1111 37.2126 20.8779 37.0803 20.4658 37.2553C20.2287 37.3564 20.0149 37.5003 19.7817 37.6131C19.5252 37.7376 19.3658 38.0214 19.4552 38.317C19.6068 38.8187 19.288 38.9314 18.9343 39.0209C18.6467 39.0909 18.3784 39.1959 18.153 39.3903C17.7954 39.7014 17.8187 39.8609 18.2541 40.0281C18.7788 40.2264 19.3308 40.2848 19.8828 40.2848C20.6835 40.2809 21.4804 40.3198 22.2656 40.4909C22.6582 40.5764 22.9692 40.767 23.043 41.2103C23.0741 41.3814 23.0236 41.4787 22.8564 41.4709C22.4755 41.4514 22.1023 41.5292 21.7369 41.5876C20.5553 41.7664 19.3619 41.6187 18.1841 41.817C18.0714 41.8364 17.9509 41.8248 17.8342 41.8287C17.1812 41.8442 16.5359 41.8053 15.879 41.957C15.2376 42.1048 14.5768 41.8831 13.9238 41.8792C12.6216 41.8714 11.3544 41.4164 10.0366 41.5603C9.70622 41.5953 9.36804 41.5681 9.04152 41.6692C8.86271 41.7237 8.69556 41.7314 8.57118 41.5642C8.47011 41.4281 8.474 41.2881 8.57118 41.1598C8.6839 41.0081 8.80829 40.837 9.03375 40.8953C9.59738 41.0431 10.0483 40.8759 10.4253 40.452C10.5808 40.277 10.783 40.2109 11.0162 40.2226C11.2144 40.2303 11.4088 40.2226 11.607 40.2226C11.6148 40.1837 11.6226 40.1448 11.6304 40.1059L11.642 40.0903ZM16.1472 35.377C16.5981 35.8009 16.225 35.832 15.984 35.9603C15.8479 36.0303 15.743 36.1626 15.638 36.2831C15.4553 36.4892 15.2376 36.637 14.9578 36.5748C14.709 36.5203 14.5807 36.6214 14.4641 36.8159C14.3008 37.0842 14.0521 37.2164 13.7644 37.3564C13.2085 37.6287 12.6993 37.9942 12.2445 38.422C12.0618 38.5931 12.0696 38.7331 12.3495 38.8226C12.9364 39.0131 13.5467 39.0364 14.1453 39.1376C14.4136 39.1842 14.5535 39.0287 14.4991 38.7409C14.4447 38.4648 14.3708 38.142 14.6196 37.9631C15.1288 37.6014 15.4786 37.0726 16.0384 36.7614C16.672 36.4076 16.7186 35.8903 16.155 35.377H16.1472ZM16.6059 34.7081C16.5632 34.9959 16.7886 35.2681 16.8469 35.5948C16.878 35.7776 17.0996 35.7659 17.2279 35.6103C17.5388 35.2292 17.9742 35.0076 18.3318 34.6887C18.5922 34.4592 18.876 34.257 19.1403 34.0392C19.4085 33.8176 19.4202 33.5142 19.2725 33.2498C19.1015 32.9426 18.8527 33.1137 18.635 33.2381C18.048 33.5764 17.4572 33.9148 16.8741 34.257C16.7264 34.3426 16.5554 34.4242 16.6059 34.7081Z" fill="#A61E2F"></path>
                        <path d="M1.57031 34.7277C1.83853 33.3316 1.7258 31.916 1.81132 30.5082C1.86962 29.5594 2.01345 28.6027 1.91238 27.646C1.89295 27.4516 1.92793 27.2221 2.01345 27.0471C2.14172 26.7827 2.09119 26.5377 2.10674 26.2732C2.12229 25.9816 2.10285 25.6782 2.14561 25.3866C2.17671 25.1688 2.16116 24.9627 2.15727 24.7449C2.15338 24.5232 2.01345 24.2744 2.24668 24.0605C2.31664 23.9982 2.32831 23.7805 2.27389 23.6871C1.95903 23.131 2.27777 22.5555 2.18837 21.9955C2.17671 21.9294 2.18059 21.8205 2.22335 21.7894C2.6626 21.4549 2.3594 21.101 2.33219 20.7121C2.27777 19.9382 2.20003 19.1644 2.12617 18.3905C2.11451 18.2582 2.16893 18.1221 2.31276 18.0716C2.511 18.0016 2.62373 17.8344 2.70147 17.6749C2.9036 17.251 3.24567 17.2199 3.61884 17.3094C4.16304 17.4377 4.73834 17.4921 5.20868 17.8499C5.34473 17.9549 5.4769 17.8577 5.56241 17.7799C5.95502 17.4144 6.31263 17.5427 6.63915 17.8538C6.81019 18.0171 6.91125 18.0366 7.11338 17.8927C7.3505 17.7216 7.66147 17.6788 7.94524 17.7216C8.64103 17.8344 9.33295 17.7838 10.0326 17.7488C10.5108 17.7216 11.02 17.7099 11.4748 17.9549C11.6924 18.0716 11.9101 18.1027 12.1395 17.9744C12.3766 17.8421 12.6059 17.7449 12.8469 18.0055C13.0879 18.2699 13.0918 18.546 12.9869 18.8532C12.9791 18.8805 12.9597 18.9038 12.9402 18.9271C12.2872 19.7632 11.9645 20.7627 11.5136 21.6999C11.191 22.3649 10.7323 22.9599 10.3941 23.621C10.2153 23.971 10.1415 24.3521 9.95489 24.706C9.23188 26.0516 8.59439 27.436 7.84806 28.7699C7.36605 29.6294 6.98122 30.5432 6.53809 31.4221C6.18824 32.1221 5.9589 32.8766 5.55075 33.5416C5.46523 33.6816 5.34473 33.7827 5.20091 33.8644C4.69558 34.1405 4.33019 33.9577 4.28743 33.3899C4.26799 33.1294 4.26799 32.8649 4.28354 32.6005C4.29909 32.2738 4.12806 32.0327 3.85207 31.9705C3.58774 31.9082 3.41671 32.161 3.30398 32.3866C3.09407 32.7988 3.10962 33.246 3.20291 33.6738C3.33896 34.2921 3.1174 34.9182 3.31564 35.5366C3.38561 35.7582 2.82197 36.3882 2.56154 36.431C2.22335 36.4894 2.10674 36.1977 1.91627 36.0032C1.55088 35.6338 1.58975 35.1827 1.57809 34.7316L1.57031 34.7277Z" fill="#A61E2F"></path>
                        <path d="M45.6196 13.2653C44.7645 13.3275 44.1931 12.8997 43.6527 12.2736C43.2524 11.8108 42.9414 11.352 42.8053 10.757C42.7354 10.4497 42.681 10.162 42.8598 9.87029C42.9181 9.77307 42.9725 9.6564 42.9764 9.54752C43.0269 8.48585 43.6955 7.91029 44.5779 7.52141C45.3203 7.19085 46.09 6.97307 46.9063 7.21029C47.7109 7.44363 48.3873 7.81307 48.6205 8.73085C48.7371 9.18196 49.0831 9.54752 49.0364 10.0764C48.9859 10.6753 48.706 11.1692 48.4378 11.6631C47.9908 12.4875 47.1551 12.8375 46.3543 13.207C46.1211 13.3158 45.8645 13.2381 45.6196 13.2653Z" fill="#A61E2F"></path>
                    </g>
                    <defs>
                        <clipPath id="clip0_1191_534" style="margin-left: 0.5rem !important;font-weight: var(--font-weight-bold);">
                            <rect width="62" height="42" fill="white"></rect>
                        </clipPath>
                    </defs>
                </svg>
            </span>
          <span class="app-brand-text menu-text fw-bolder ms-2">EDCTP</span>
        </a>
      </div>
      <ul class="menu-inner py-1">
        <!-- Always visible to all authenticated users -->
        <li class="menu-item" :class="{ active: $route.name === 'MyProfile' }" v-if="canViewRoute('MyProfile')">
          <router-link class="menu-link" to="/my-profile">
            <i class="menu-icon bi bi-person-circle"></i>
            <div>My Profile</div>
          </router-link>
        </li>

        <li class="menu-item" :class="{ active: $route.name === 'Forums' }" v-if="canViewRoute('Forums')">
          <router-link class="menu-link" to="/forums">
            <i class="menu-icon bi bi-chat-square-text"></i>
            <div>Forums</div>
          </router-link>
        </li>

        <li class="menu-item" :class="{ active: $route.name === 'MySurveys' }" v-if="canViewRoute('MySurveys')">
          <router-link class="menu-link" to="/my-surveys">
            <i class="menu-icon bi bi-clipboard-check"></i>
            <div>My Surveys</div>
          </router-link>
        </li>

        <!-- Administration Section - Only for Super Admin and EDCTP Admin -->
        <template v-if="hasAdminAccess">
          <li class="menu-header small text-uppercase">
            <span class="menu-header-text">Administration</span>
          </li>

          <li class="menu-item" :class="{ active: $route.name === 'Email' }" v-if="canViewRoute('Email')">
            <router-link class="menu-link" to="/email">
              <i class="menu-icon bi bi-envelope"></i>
              <div>Email</div>
            </router-link>
          </li>

          <li class="menu-item" :class="{ active: $route.name === 'SentMail' }" v-if="canViewRoute('SentMail')">
            <router-link class="menu-link" to="/sent-mail">
              <i class="menu-icon bi bi-envelope-open"></i>
              <div>Sent Mail</div>
            </router-link>
          </li>

          <li class="menu-item" :class="{ active: $route.name === 'Authorization' }" v-if="canViewRoute('Authorization')">
            <router-link class="menu-link" to="/authorization">
              <i class="menu-icon bi bi-shield-check"></i>
              <div>Authorization</div>
            </router-link>
          </li>

          <li class="menu-item" :class="{ active: $route.name === 'WorkingGroups' }" v-if="canViewRoute('WorkingGroups')">
            <router-link class="menu-link" to="/working-groups">
              <i class="menu-icon bi bi-people"></i>
              <div>Working Groups</div>
            </router-link>
          </li>

          <li class="menu-item" :class="{ active: $route.name === 'Surveys' }" v-if="canViewRoute('Surveys')">
            <router-link class="menu-link" to="/surveys">
              <i class="menu-icon bi bi-clipboard-data"></i>
              <div>Surveys</div>
            </router-link>
          </li>

          <li class="menu-item" :class="{ active: $route.name === 'Reports' }" v-if="canViewRoute('Reports')">
            <router-link class="menu-link" to="/reports">
              <i class="menu-icon bi bi-file-earmark-bar-graph"></i>
              <div>Reports</div>
            </router-link>
          </li>

          <li class="menu-item" :class="{ active: $route.name === 'ForumAdmin' }" v-if="canViewRoute('ForumAdmin')">
            <router-link class="menu-link" to="/forum-admin">
              <i class="menu-icon bi bi-gear"></i>
              <div>Forum Admin</div>
            </router-link>
          </li>
        </template>

        <!-- CMS Section - Only for Super Admin and CMS Admin -->
        <template v-if="hasCMSAccess">
          <li class="menu-header small text-uppercase">
            <span class="menu-header-text">CMS</span>
          </li>

<!--          <li class="menu-item" :class="{ active: $route.name === 'CMSHome' }" v-if="canViewRoute('CMSHome')">-->
<!--            <router-link class="menu-link" to="/cms/home">-->
<!--              <i class="menu-icon bi bi-house"></i>-->
<!--              <div>Home</div>-->
<!--            </router-link>-->
<!--          </li>-->

<!--          <li class="menu-item" :class="{ active: $route.name === 'AboutUs' }" v-if="canViewRoute('AboutUs')">-->
<!--            <router-link class="menu-link" to="/about-us">-->
<!--              <i class="menu-icon bi bi-info-circle"></i>-->
<!--              <div>About Us</div>-->
<!--            </router-link>-->
<!--          </li>-->

<!--          <li class="menu-item" :class="{ active: $route.name === 'Networks' }" v-if="canViewRoute('Networks')">-->
<!--            <router-link class="menu-link" to="/networks">-->
<!--              <i class="menu-icon bi bi-diagram-3"></i>-->
<!--              <div>Networks</div>-->
<!--            </router-link>-->
<!--          </li>-->

          <li class="menu-item" :class="{ active: $route.name === 'FundingTraining' }" v-if="canViewRoute('FundingTraining')">
            <router-link class="menu-link" to="/funding-training">
              <i class="menu-icon bi bi-bank"></i>
              <div>Funding & Training</div>
            </router-link>
          </li>

          <li class="menu-item" :class="{ active: $route.name === 'News' }" v-if="canViewRoute('News')">
            <router-link class="menu-link" to="/news">
              <i class="menu-icon bi bi-newspaper"></i>
              <div>News</div>
            </router-link>
          </li>

          <li class="menu-item" :class="{ active: $route.name === 'Gallery' }" v-if="canViewRoute('Gallery')">
            <router-link class="menu-link" to="/gallery">
              <i class="menu-icon bi bi-images"></i>
              <div>Gallery</div>
            </router-link>
          </li>
        </template>
      </ul>
    </aside>

    <!-- Layout container -->
    <div class="layout-page" :class="{ 'with-impersonation-banner': isImpersonating }">
      <!-- Navbar -->
      <nav class="layout-navbar container-fluid navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme" style="background: transparent">
        <div class="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
          <button class="nav-item nav-link px-0 me-xl-4" @click="toggleMenu">
            <i class="bi bi-list"></i>
          </button>
        </div>
        <div class="navbar-nav-right d-flex align-items-center ms-auto">
          <!-- User Dropdown -->
          <ul class="navbar-nav flex-row align-items-center ms-auto">
            <li class="nav-item navbar-dropdown dropdown-user dropdown">
              <a
                class="nav-link dropdown-toggle hide-arrow"
                href="#"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div class="avatar avatar-online">
                  <img
                    :src="userAvatar"
                    alt="User Avatar"
                    class="w-px-40 h-auto rounded-circle"
                    @error="onAvatarError($event, activeUser)"
                    style="height: 40px !important; width: 40px !important;"
                  />
                </div>
              </a>
              <ul class="dropdown-menu dropdown-menu-end">
                <li>
                  <div class="dropdown-item">
                    <div class="d-flex">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar avatar-online">
                          <img
                            :src="userAvatar"
                            alt="Profile Picture"
                            class="profile-picture"
                            @error="onAvatarError($event, activeUser)"
                            style="height: 40px !important; width: 40px !important;"
                          >
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <span class="fw-semibold d-block">{{ activeUser?.name || 'User' }}</span>
                        <small class="text-muted">{{ displayProfession }}</small>
                        <small v-if="isImpersonating" class="text-warning d-block mt-1">
                          <i class="bi bi-person-badge me-1"></i>Impersonating
                        </small>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="dropdown-divider"></div>
                </li>
                <li>
                  <router-link class="dropdown-item" to="/my-profile">
                    <i class="bi bi-person me-2"></i>
                    <span class="align-middle">My Profile</span>
                  </router-link>
                </li>
                <li v-if="isImpersonating">
                  <div class="dropdown-divider"></div>
                </li>
                <li v-if="isImpersonating">
                  <button class="dropdown-item text-warning" @click="handleStopImpersonation">
                    <i class="bi bi-arrow-left me-2"></i>
                    <span class="align-middle">Stop Impersonation</span>
                  </button>
                </li>
                <li>
                  <div class="dropdown-divider"></div>
                </li>
                <li>
                  <button class="dropdown-item" @click="handleLogout">
                    <i class="bi bi-box-arrow-right me-2"></i>
                    <span class="align-middle">Log Out</span>
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>

      <!-- Content wrapper -->
      <div class="content-wrapper">
        <div class="container-fluid flex-grow-1 container-p-y" style="padding-right: 5rem; padding-left: 5rem;">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { avatarMixin } from '@/mixins/avatarMixin'
import UserService from '@/services/users/UserService'
import AuthenticationService from '@/services/authentication/AuthenticationService'

export default {
  name: 'DashboardLayout',
  mixins: [avatarMixin],
  data() {
    return {
      menuCollapsed: false,
      stoppingImpersonation: false,
      headerAvatarVersion: null,
      // Define route permissions directly in the component
      routePermissions: {
        // Always visible to all authenticated users
        'MyProfile': ['Super Admin', 'EDCTP Admin', 'CMS Admin', 'Fellow', 'Testing User'],
        'Forums': ['Super Admin', 'EDCTP Admin', 'CMS Admin', 'Fellow', 'Testing User'],
        'MySurveys': ['Super Admin', 'EDCTP Admin', 'CMS Admin', 'Fellow', 'Testing User'],

        // Administration routes
        'Email': ['Super Admin'],
        'Authorization': ['Super Admin', 'EDCTP Admin'],
        'WorkingGroups': ['Super Admin', 'EDCTP Admin'],
        'Surveys': ['Super Admin'],
        'Reports': ['Super Admin'],
        'ForumAdmin': ['Super Admin', 'EDCTP Admin'],

        // CMS routes
        'CMSHome': ['Super Admin', 'CMS Admin'],
        'AboutUs': ['Super Admin', 'CMS Admin'],
        'Networks': ['Super Admin', 'CMS Admin'],
        'FundingTraining': ['Super Admin', 'CMS Admin'],
        'News': ['Super Admin', 'CMS Admin'],
        'Gallery': ['Super Admin', 'CMS Admin']
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('users', ['isImpersonating', 'effectiveUserRole', 'currentUser']),

    activeUser() {
      // When impersonating, currentUser is the impersonated user
      return this.isImpersonating ? this.currentUser : this.user
    },

    userAvatar() {
      const avatarUrl = this.getUserAvatar(this.activeUser)
      return this.withCacheBuster(avatarUrl, this.headerAvatarVersion)
    },

    userRole() {
      // When impersonating, use the impersonated user's role
      if (this.isImpersonating && this.currentUser) {
        return this.currentUser.roles && this.currentUser.roles.length > 0
          ? this.currentUser.roles[0].name
          : 'Fellow'
      }

      // Otherwise use the normal user's role
      return this.user?.roles && this.user.roles.length > 0
        ? this.user.roles[0].name
        : null
    },

    hasAdminAccess() {
      // Get the effective role
      let effectiveRole = this.userRole

      if (this.isImpersonating && this.currentUser) {
        effectiveRole = this.currentUser.roles && this.currentUser.roles.length > 0
          ? this.currentUser.roles[0].name
          : 'Fellow'
      }

      return ['Super Admin', 'EDCTP Admin'].includes(effectiveRole)
    },

    hasCMSAccess() {
      // Get the effective role
      let effectiveRole = this.userRole

      if (this.isImpersonating && this.currentUser) {
        effectiveRole = this.currentUser.roles && this.currentUser.roles.length > 0
          ? this.currentUser.roles[0].name
          : 'Fellow'
      }

      return ['Super Admin', 'CMS Admin'].includes(effectiveRole)
    },

    displayProfession() {
      const activeUser = this.activeUser

      if (activeUser?.fellow_details?.current_job_title) {
        return activeUser.fellow_details.current_job_title
      }

      if (activeUser?.fellowship_details?.current_job_title) {
        return activeUser.fellowship_details.current_job_title
      }

      if (activeUser?.profession) {
        return activeUser.profession
      }

      // Default fallback
      return 'EDCTP User'
    }
  },

  mounted() {
    this.loadUserData()
    window.addEventListener('user-avatar-updated', this.handleUserAvatarUpdated)

    this.$nextTick(() => {
      const dropdownEl = this.$el.querySelector('[data-bs-toggle="dropdown"]')
      if (dropdownEl) {
        new window.bootstrap.Dropdown(dropdownEl)
      }
    })
  },

  methods: {
        handleUserAvatarUpdated(event) {
          const detail = event?.detail || {}
          const activeUserId = this.activeUser?.id

          if (!activeUserId || String(activeUserId) !== String(detail.userId)) {
            return
          }

          const avatarVersion = detail.avatarVersion || Date.now()
          this.headerAvatarVersion = avatarVersion

          if (detail.avatar && this.$store?.state?.auth?.user) {
            const authUser = this.$store.state.auth.user
            if (String(authUser.id) === String(activeUserId)) {
              this.$store.commit('auth/SET_USER', {
                ...authUser,
                avatar: detail.avatar,
                avatar_url: detail.avatar,
                avatar_version: avatarVersion
              })
            }
          }

          if (detail.avatar && this.$store?.state?.users?.currentUser) {
            const currentUser = this.$store.state.users.currentUser
            if (String(currentUser.id) === String(activeUserId)) {
              this.$store.commit('users/SET_CURRENT_USER', {
                ...currentUser,
                avatar: detail.avatar,
                avatar_url: detail.avatar,
                avatar_version: avatarVersion
              })
            }
          }
        },

    ...mapActions('auth', ['logout']),
    ...mapActions('users', ['loadCurrentAuthenticatedUser', 'checkImpersonationStatus']),

    async loadUserData() {
      try {
        // Load the current authenticated user (will handle impersonation)
        await this.loadCurrentAuthenticatedUser()

        // Check impersonation status
        await this.checkImpersonationStatus()
      } catch (error) {
        console.error('Error loading user data:', error)
      }
    },

    toggleMenu() {
      this.menuCollapsed = !this.menuCollapsed
    },

    async handleLogout() {
      try {
        await this.logout()
        this.$router.push('/')
      } catch (error) {
        console.error('Logout failed:', error)
      }
    },

    async handleStopImpersonation() {
      if (this.stoppingImpersonation) return

      this.stoppingImpersonation = true

      try {
        const response = await UserService.stopImpersonation()
        const isSuccess = response?.Data?.status === 'success' || response?.status === 'success'

        if (isSuccess) {
          const data = response.Data?.data || response.data

          if (!data?.access_token) {
            throw new Error('No access token received for original user')
          }

          // Restore a regular authenticated session for the original user
          AuthenticationService.setToken(data.access_token)

          if (data.original_user) {
            AuthenticationService.setUserData(data.original_user)
          }

          if (this.$store && data.original_user) {
            this.$store.commit('auth/SET_USER', data.original_user)
            this.$store.commit('auth/SET_TOKEN', AuthenticationService.getJwt())
            this.$store.commit('auth/SET_IMPERSONATION', {
              isImpersonating: false,
              originalUser: null,
              impersonatedUser: null
            })
          }

          this.$toast?.success('Impersonation stopped successfully')

          // Redirect to own dashboard without a full page reload
          setTimeout(() => {
            this.$router.push('/my-profile')
          }, 500)
        }
      } catch (error) {
        console.error('Error stopping impersonation:', error)
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to stop impersonation'
        this.$toast?.error(errorMessage)
      } finally {
        this.stoppingImpersonation = false
      }
    },

    canViewRoute(routeName) {
      // Get the current effective role (impersonated user's role if impersonating)
      let effectiveRole = this.userRole

      if (this.isImpersonating && this.currentUser) {
        // Use the impersonated user's role
        effectiveRole = this.currentUser.roles && this.currentUser.roles.length > 0
          ? this.currentUser.roles[0].name
          : 'Fellow'
      }

      // Get allowed roles for this route
      const allowedRoles = this.routePermissions[routeName]

      if (!allowedRoles) {
        return true // If no permissions defined, allow access
      }

      // Check if the effective role is in allowed roles
      const hasAccess = allowedRoles.includes(effectiveRole)

      return hasAccess
    }
  },

  beforeUnmount() {
    window.removeEventListener('user-avatar-updated', this.handleUserAvatarUpdated)
  }
}
</script>

<style scoped>
/* Impersonation Banner Styles */
.impersonation-banner {
  background: #fff3cd;
  border-bottom: 2px solid #ffc107;
  padding: 0.75rem 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1040;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.impersonation-banner .container-fluid {
  padding: 0 2rem;
}

.impersonation-banner strong {
  color: #856404;
}

.impersonation-banner .btn-warning {
  background-color: #ffc107;
  border-color: #ffc107;
  color: #212529;
}

.impersonation-banner .btn-warning:hover {
  background-color: #e0a800;
  border-color: #d39e00;
}

/* Adjust layout when impersonation banner is visible */
.layout-page.with-impersonation-banner {
  margin-top: 60px;
}

/* Spinner for button */
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

/* Layout Styles */
.layout-wrapper {
  display: flex;
  flex-direction: row;
  min-height: 100vh;
}

.layout-menu {
  width: 260px;
  background: #fff;
  border-right: 1px solid #d9dee3;
  transition: all 0.3s ease;
}

.layout-menu.menu-collapsed {
  width: 78px;
}

.layout-page {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.layout-navbar {
  padding-right: 5rem;
  padding-left: 5rem;
  background: transparent;
  border-bottom: 0;
  height: 60px;
  z-index: 999;
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f5f5f9;
}

.container-p-y {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

/* Menu Styles */
.app-brand {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #d9dee3;
}

.app-brand-text {
  color: #566a7f;
  font-size: var(--font-size-lg);
}

.menu-inner {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-item {
  margin-bottom: 0.25rem;
}

.menu-header {
  padding: 1rem 1.5rem 0.5rem;
  margin-top: 1rem;
  color: #a8b1bb;
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.5px;
}

.menu-header:first-child {
  margin-top: 0;
}

.menu-header-text {
  font-size: var(--font-size-xs);
}

.menu-link {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  color: #697a8d;
  text-decoration: none;
  border-radius: 0.375rem;
  margin: 0 0.75rem;
  transition: all 0.2s ease;
  position: relative;
}

.menu-link:hover {
  background: #f1f1f5;
  color: #009CAD;
  text-decoration: none;
}

.menu-item.active .menu-link {
  background: #009CAD;
  color: #fff;
  box-shadow: 0 2px 6px rgba(105, 108, 255, 0.4);
}

.menu-icon {
  width: 20px;
  margin-right: 0.75rem;
  text-align: center;
  font-size: var(--font-size-base);
}

.menu-arrow {
  margin-left: auto;
  transition: transform 0.2s ease;
  font-size: var(--font-size-sm);
}

/* Avatar Styles */
.avatar {
  position: relative;
  display: inline-block;
}

.avatar-online::before {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 12px;
  height: 12px;
  background: #71dd37;
  border: 2px solid #fff;
  border-radius: 50%;
}

/* Footer Styles */
.content-footer {
  background: #fff;
  border-top: 1px solid #d9dee3;
  padding: 1rem 0;
}

.footer-link {
  color: #697a8d;
  text-decoration: none;
}

.footer-link:hover {
  color: #009CAD;
  text-decoration: none;
}

/* Responsive */
@media (max-width: 1199.98px) {
  .layout-menu {
    position: fixed;
    top: 0;
    left: -260px;
    height: 100vh;
    z-index: 1000;
  }

  .layout-menu.menu-collapsed {
    left: 0;
  }

  .layout-page {
    margin-left: 0;
  }

  .layout-page.with-impersonation-banner {
    margin-top: 60px;
  }
}

/* Theme Support */
.bg-menu-theme {
  background: #fff;
}

.bg-navbar-theme {
  background: #fff;
}

.bg-footer-theme {
  background: #fff;
}
</style>
